import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { OracleServiceCloudCopySource } from 'app/model/pipeline/copysource/oracle-service-cloud.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleServiceCloudCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class OracleServiceCloudCopySourceAdapter extends CopySourceAdapter<
    OracleServiceCloudCopySource,
    Model.OracleServiceCloudSource
> {
    protected override async _toResource(
        copySource: OracleServiceCloudCopySource
    ): Promise<Model.OracleServiceCloudSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(OracleServiceCloudCopySource).name);
    }

    protected override async _toModel(
        resource: Model.OracleServiceCloudSource,
        copyActivity: CopyActivity
    ): Promise<OracleServiceCloudCopySource> {
        return this._toTabularModel(resource, copyActivity, OracleServiceCloudCopySource.MODEL);
    }
}
